import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { QuestionInterface } from '../../../../types';

export interface ReferenceChangesDialogProps {
  referencedAnswers?: Array<QuestionInterface>,
}

const StyledDiv = styled.div`
  font-family: "Poppins Light", "Poppins", sans-serif;
  font-weight: 300;
  font-size: 14px;
  color: #333333;

  .copy {
    padding-top: 10px;
  }

  .content {
    margin-top: 15px;
    margin-bottom: 0;
  }

  .referencesQuestionsList {
    padding: 0;
    margin-top: 25px;
    padding-left: 15px;
    list-style-position: inside;
    .references {
      list-style-type: disc;
      padding-left: 15px;
      line-height: 25px;
    }
  }
`;

function ReferenceChanges({ referencedAnswers }: ReferenceChangesDialogProps) {
  const { t } = useTranslation();

  return (
    <StyledDiv>

      <div className="copy">
        {t('Procedure.Dialog.Reference Questions Updated.Instructions')}
      </div>

      <div className="content">
        <div>
          {referencedAnswers && referencedAnswers.length > 0 ? (
            referencedAnswers.map(({ questionText, questionId, references }) => (
              <ul key={questionId} className="referencesQuestionsList">
                <li>{questionText}</li>
                <ul key={`${questionId}-references`} className="references">
                  {references?.map(({
                    questionId: referencingQuestionId, visitNumber, visitName, procedureName, questionText: referencingQuestionText,
                  }, i) => (
                    <li key={`${referencingQuestionId}-${i}`}>
                      {`${t('Procedure.Dialog.Reference Questions Updated.Visit')} ${visitNumber} - ${visitName}, ${procedureName}, ${referencingQuestionText}`}
                    </li>
                  ))}
                </ul>
              </ul>
            ))
          ) : (
            // This should theoretically never be hit
            <div>{t('Procedure.Dialog.Reference Questions Updated.None Found')}</div>
          )}
        </div>
      </div>
    </StyledDiv>
  );
}

ReferenceChanges.defaultProps = {
  referencedAnswers: [],
};

export default ReferenceChanges;
